<div class="p-4 py-8 w-10 mx-auto my-0">
  <div class="flex align-items-start justify-content-between">
    <h3 i18n>Titles</h3>
    <button
      pButton
      label="Add Title"
      type="button"
      class="p-button-raised p-button-warning"
      icon="pi pi-plus-circle"
      style="margin-bottom: 10px"
      (click)="createClicked()"
    ></button>
  </div>
  <p-table
    #dt
    class="titles-table"
    styleClass="p-datatable-sm"
    [value]="filteredTitles"
    [paginator]="true"
    [(rows)]="pageSize"
    [(first)]="first"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="translateCurrentPageReportTemplate()"
    [resizableColumns]="true"
    [rowsPerPageOptions]="availablePageSizes"
    [loading]="isLoading"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-end py-3">
        <span class="p-float-label">
          <input
            id="float-input"
            type="text"
            pInputText
            [(ngModel)]="selectedSearchText"
            (ngModelChange)="searchTextChanged()"
          />
          <label for="float-input" i18n>Search</label>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="current" i18n>Name</th>
        <th class="current" i18n>Countries</th>
        <th class="current text-right pr-6" i18n>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-title>
      <tr>
        <td>{{ title.name }}</td>
        <td>
          <span *ngFor="let country of countries">
            <img
              *ngIf="title.countryIds.includes(country.id)"
              src="{{ country.flagUrl }}"
              style="display: inline-block"
              width="30"
            />
            {{ ' ' }}
          </span>
        </td>
        <td class="actions text-right">
          <button
            pButton
            type="button"
            icon="pi pi-file-edit"
            class="p-button-outlined p-button-warning"
            (click)="editClicked($event, title)"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-warning"
            (click)="confirmDelete($event, title)"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-toast></p-toast>
  <p-confirmPopup></p-confirmPopup>
</div>
